import styled, { css } from 'styled-components';

export const PhasesWrapper = styled.div`
  overflow: hidden;
  position: relative;
  ul.scroll-ul {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    overflow-x: auto;
    justify-items: center;
    line-height: 1.2em;
  }
  border-bottom: 1px solid ${props => props.theme.colors.gray};
  margin-bottom: 16px;
  ${props => props.isSpecialChampionship && !props.isMobile && !props.isRegular && css`
    border-bottom: 0;
  `};
  ${props => props.isSpecialChampionship && css`
    margin-bottom: 0;
  `};
`;

export const SubPhasesWrapper = styled.div`
  overflow: hidden;
  position: relative;
  ul.scroll-ul {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    overflow-x: auto;
    justify-items: center;
    line-height: 1.2em;
  }
  border-bottom: 1px solid ${props => props.theme.colors.gray};
  margin-bottom: 30px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin-bottom: 10px;
    overflow: auto;
    white-space: nowrap;
  }
`;

export const CupTabbarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${props => (props.margin ? props.margin : '0')};
  ${props => props.isSpecialChampionship && !props.isRegular && props.isInnerMenu && !props.isMobile && css`
    margin-top: -6px;
  `};
  ${props => props.isSpecialChampionship && props.isRegular && props.isMobile && !props.isInnerMenu && css`
    margin-bottom: 20px;
  `};
  ${props => props.isSpecialChampionship && !props.isRegular && props.isMobile && css`
    margin-top: 10px;
  `};
  ${props => props.isVolleyChampionship && !props.isMobile && css`
    margin-top: -20px;
  `};
`;

export const NodeTitleClone = styled.div`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/components/CupCalendarTabbar/styles.js